import { Injectable } from '@angular/core';
import { User } from '@socrates/common';
import { IUserRepo } from '../interfaces/iuser.repo';

@Injectable()
export class TestUserRepo extends IUserRepo {
	private _user: User;

	private userJson: any = {
		username: 'jonny.clutch',
		first_name: 'Jonny',
		last_name: 'Clutch',
		roles: ['admin'],
		groups: [
			'ION_DEV_SUPER_ADMIN', 'ION_QA_SUPER_ADMIN', 'ION_TRAIN_SUPER_ADMIN', 'ION_PROD_SUPER_ADMIN'
		],
		expires: '2020-02-06T20:52:06Z',
	};

	constructor() {
		super();
	}

	async updateOwnPassword(_pwd: string): Promise<boolean> {
		return true;
	}

	async updateOwnUser(user: User): Promise<User> {
		this._user = user;
		return user;
	}

	async requestPasswordReset(_username: string): Promise<boolean> {
		return true;
	}

	async passwordResetConfirm(_username: string, _newPassword: string, _passwordCode: string): Promise<User> {
		this._user = new User(this.userJson);
		return this._user;
	}

	async firstLoginResetPassword(_username: string, _newPassword: string): Promise<User> {
		this._user = new User(this.userJson);
		return this._user;
	}

	logout(): void {}

	async loginUser(_userCredentials: any): Promise<User> {
		this._user = new User(this.userJson);
		return this._user;
	}

	async validateSession(): Promise<User> {
		this._user = new User(this.userJson);
		return this._user;
	}

	userFromSession(): User {
		return null;
	}

	async listPublicOrgs(): Promise<any[]> {
		return [];
	}

	async signup(_payload: any): Promise<any> {
		return { joinMode: 'OPEN', message: 'Account created.' };
	}

	async getOwnProfile(): Promise<any> {
		return { firstName: 'Jonny', lastName: 'Clutch', email: 'jonny.clutch@example.com', timezone: 'UTC', notifyFloorEvents: true, notifyObjections: true, notifyDecisions: true };
	}

	async updateProfile(_payload: any): Promise<void> {}

	async resolveInvite(_token: string): Promise<{ orgId: string; orgName: string }> {
		return { orgId: 'test-org-id', orgName: 'Test Org' };
	}

	async getMyAccount(): Promise<{ trustLevel: number; accountState: string }> {
		return { trustLevel: 1, accountState: 'Active' };
	}
}
